export const SERVICES = [
    {
        icon: "◈",
        title: "Ceramic Coating",
        desc: "Nano-ceramic bond that shields paint for 5+ years of mirror-like protection.",
        col: "cyan",
        features: ["Hydrophobic", "UV Protection", "9H Hardness", "Self-Cleaning"]
    },
    {
        icon: "◉",
        title: "Paint Correction",
        desc: "Multi-stage machine polish eliminates swirls, halos and micro-scratches entirely.",
        col: "violet",
        features: ["Swirl Removal", "Gloss Enhancement", "Deep Wet Look", "Scratch Removal"]
    },
    {
        icon: "✦",
        title: "Full Detail",
        desc: "Complete interior + exterior restoration — every panel, every fiber, every surface.",
        col: "amber",
        features: ["Complete Package", "Engine Bay", "Wheel-off", "Odor Elimination"]
    },
    {
        icon: "❋",
        title: "Interior Detailing",
        desc: "Steam clean, leather conditioning, odor elimination and headliner refresh.",
        col: "rose",
        features: ["Deep Steam Clean", "Leather Treatment", "Odor Removal", "Stain Protection"]
    },
    {
        icon: "⬡",
        title: "PPF Installation",
        desc: "Self-healing paint protection film deflects chips, bugs and road debris invisibly.",
        col: "emerald",
        features: ["Self-Healing", "Invisible Shield", "10 Year Warranty", "Scratch Resistant"]
    },
    {
        icon: "◬",
        title: "Window Tinting",
        desc: "Ceramic tint blocks 99% UV, reduces heat, and adds sleek privacy to any build.",
        col: "yellow",
        features: ["99% UV Block", "Heat Reduction", "Lifetime Warranty", "Glare Reduction"]
    },
];

export const PKG = [
    { n: "GLOSS", p: "149", f: ["Exterior Hand Wash", "Tire & Trim Dressing", "Window Clean", "Interior Vacuum", "Dash Wipe Down"], badge: null },
    { n: "DAZZLE", p: "349", f: ["Everything in Gloss", "Clay Bar Treatment", "Single-Stage Polish", "Interior Deep Clean", "Leather Conditioning", "Odor Elimination"], badge: "BEST VALUE" },
    { n: "PRESTIGE", p: "799", f: ["Everything in Dazzle", "2-Stage Paint Correction", "Pro Ceramic Coat", "Engine Bay Detail", "Headlight Restoration", "12-Month Warranty"], badge: "ELITE" },
];